import React, { useState } from "react"; // ✅ this imports useState
import MainTitle from "../../muiHome/mainTitle";
import {
  Card,
  Grid,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography, // ✅ this fixes Typography error
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const ReportHumanRightsDayCelebration = () => {
  const [openImg, setOpenImg] = useState(false);
  const [previewImg, setPreviewImg] = useState('');

  const handleImgPreview = (img) => {
    setOpenImg(true);
    setPreviewImg(img);
  };

 const items = [
  { img: "/assets/img/SOL/event/event1_mg16.jpg" }, 
];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MainTitle title="Report On Human Rights Day Celebration" />
      </Grid>

      <Grid item xs={12}>
        <Typography fontSize="14px" fontFamily="sans-serif">
          <p>Date: 10th December 2024</p>
          <p>Venue: Seminar Hall, MVN University</p>
          <p>Organized by: School of Law, MVN University</p>
          <p>Theme: "Dignity, Freedom, and Justice for All"</p>

          <p>Human Rights Day is observed annually on 10th December to commemorate the adoption of the Universal Declaration of Human Rights (UDHR) by the United Nations General Assembly in 1948. This day serves as a reminder of the fundamental rights and freedoms entitled to every individual, regardless of nationality, gender, ethnicity, or background.
To mark this occasion, MVN University organized a thought-provoking and interactive event aimed at spreading awareness about human rights, their significance, and challenges in contemporary society.
</p>
        </Typography>
      </Grid>

      {items.map((item, index) => (
  <Grid item xs={3} textAlign="center" key={index}>
    <Card
      sx={{
        height: "300px",
        padding: "10px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onClick={() => handleImgPreview(item.img)}
    >
      <CardMedia
        component="img"
        height="100%"
        image={item.img}
        alt="Event"
        style={{ height: "100%", width: "100%", objectFit: "contain" }}
      />
    </Card>
  </Grid>
))}

      <Dialog open={openImg} onClose={() => setOpenImg(false)}>
        <DialogTitle>
          <IconButton
            edge="end"
            onClick={() => setOpenImg(false)}
            aria-label="close"
            sx={{
              position: 'absolute',
              color: '#000',
              top: 0,
              right: 25
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img src={previewImg} height="100%" width="auto" alt="Preview" />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default ReportHumanRightsDayCelebration;
